import { render, staticRenderFns } from "./pending_checks.vue?vue&type=template&id=5b37588c"
import script from "./pending_checks.vue?vue&type=script&lang=js"
export * from "./pending_checks.vue?vue&type=script&lang=js"
import style0 from "./pending_checks.vue?vue&type=style&index=0&id=5b37588c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports